(function($) {

   $(document).ready(function() {

      $('.special_slider').each(function(index) {

         let special_slider = $(this);
         let slidesPerView = parseInt(special_slider.data('slidesperview'));
         let slideCount = $('.swiper-slide', special_slider).length;

         if (slidesPerView < 1) slidesPerView = 4;
         if (slideCount < slidesPerView) {
            slidesPerView = slideCount;
         }

         let delay = parseInt( special_slider.data('delay') );
         if (isNaN(delay) ) delay = 3; // seconds }

         let autoplay_options = {
            delay: (delay * 1000),
            disableOnInteraction: true
         }

         if ( delay <= 0) autoplay_options = false;

         var special_slider_swiper = new Swiper(special_slider[0], {

            direction: 'horizontal',
            loop: true,

            a11y: {
               scrollOnFocus: false,
            },

            speed: 500,

            pagination: {
               el: special_slider.find('.swiper-pagination')[0],
               clickable: true,
            },

            navigation: {
               nextEl: special_slider.find('.swiper-button-next')[0],
               prevEl: special_slider.find('.swiper-button-prev')[0],
            },

            autoplay: autoplay_options,


            slidesPerView: slidesPerView,
            spaceBetween: 0,

            breakpoints: {
               10: {
                  slidesPerView: 1,
                  spaceBetween: 0
               },
               680: {
                  slidesPerView: 2,
                  spaceBetween: 0
               },
               1200: {
                  slidesPerView: 3,
                  spaceBetween: 0
               },
               1440: {
                  slidesPerView: slidesPerView,
                  spaceBetween: 0
               }
            },

            on: {
               init: function() {
                  updateNavPosition(special_slider);
               },
               resize: function() {
                  updateNavPosition(special_slider);
               }
            }

         });

         function updateNavPosition($slider) {

            let $activeSlide = $slider.find('.swiper-slide-active');
            let $img = $activeSlide.find('.slide_image_cont').first();

            if (!$img.length) return;

            let imgHeight = $img[0].getBoundingClientRect().height;

            let $prev = $slider.find('.swiper-button-prev');
            let $next = $slider.find('.swiper-button-next');

            $prev.css('top', (imgHeight / 2) + 'px');
            $next.css('top', (imgHeight / 2) + 'px');

         }

         // fallback falls images lazy loaden
         $(window).on('load', function() {
            updateNavPosition(special_slider);
         });

         $(".swiper-wrapper", special_slider).wrap('<div class="swiper-wrapper-wrapper"></div>');

      });

   });

})(jQuery);
